define(function(require, exports, module) {
    'use strict';
    const addressLookupView = require('common/addressLookupSwiss/addressLookupView');

    module.exports = addressLookupView.extend({
        handleActionResetClick: function(event) {
            event.preventDefault();

            this.childViews.forEach((view) => view.reset());

            this.$el.find('.fn-action-manual').addClass('address-lookup-hidden');
            this.$el.find('.fn-action-reset').addClass('address-lookup-hidden');
        }
    });
});
